import React, { useEffect, useState, useRef } from 'react';
const logo = 'https://uploadthingy.s3.us-west-1.amazonaws.com/kUJkvt7eZfsF9tkKGwhnju/mintextract%C2%A9.svg';
const pageSequences: Record<string, string[]> = {
  complexity: ['https://em-content.zobj.net/source/microsoft/379/world-map_1f5fa-fe0f.png', 'https://em-content.zobj.net/source/microsoft/379/magnifying-glass-tilted-left_1f50d.png', 'https://em-content.zobj.net/source/microsoft/379/gear_2699-fe0f.png', 'https://em-content.zobj.net/source/microsoft/379/puzzle-piece_1f9e9.png', 'https://em-content.zobj.net/source/microsoft/379/triangular-ruler_1f4d0.png', 'https://em-content.zobj.net/source/microsoft/379/thinking-face_1f914.png'],
  research: ['https://em-content.zobj.net/source/microsoft/379/microscope_1f52c.png', 'https://em-content.zobj.net/source/microsoft/379/bar-chart_1f4ca.png', 'https://em-content.zobj.net/source/microsoft/379/light-bulb_1f4a1.png', 'https://em-content.zobj.net/source/microsoft/379/bullseye_1f3af.png', 'https://em-content.zobj.net/source/microsoft/379/test-tube_1f9ea.png', 'https://em-content.zobj.net/source/microsoft/379/balance-scale_2696-fe0f.png'],
  systems: ['https://em-content.zobj.net/source/microsoft/379/brick_1f9f1.png', 'https://em-content.zobj.net/source/microsoft/379/wrench_1f527.png', 'https://em-content.zobj.net/source/microsoft/379/straight-ruler_1f4cf.png', 'https://em-content.zobj.net/source/microsoft/379/seedling_1f331.png', 'https://em-content.zobj.net/source/microsoft/379/link_1f517.png', 'https://em-content.zobj.net/source/microsoft/379/building-construction_1f3d7-fe0f.png']
};
export function Logo({
  onClick,
  currentPage = 'home'
}: {
  onClick?: () => void;
  currentPage?: string;
}) {
  const [currentImage, setCurrentImage] = useState<string>(logo);
  const [isAnimating, setIsAnimating] = useState<boolean>(false);
  const animationRef = useRef<NodeJS.Timeout | null>(null);
  const indexRef = useRef<number>(0);
  const prevPageRef = useRef<string>(currentPage);
  useEffect(() => {
    // Clear any existing animation
    if (animationRef.current) {
      clearInterval(animationRef.current);
      animationRef.current = null;
    }
    // Reset to logo when on home page
    if (currentPage === 'home') {
      setCurrentImage(logo);
      setIsAnimating(false);
      indexRef.current = 0;
      prevPageRef.current = currentPage;
      return;
    }
    // Get the sequence for this page
    const sequence = pageSequences[currentPage] || pageSequences.complexity;
    // Start animation when switching to any content page
    if (currentPage !== 'home' && prevPageRef.current !== currentPage) {
      setIsAnimating(true);
      setCurrentImage(logo);
      indexRef.current = 0;
      animationRef.current = setInterval(() => {
        if (indexRef.current >= sequence.length) {
          if (animationRef.current) {
            clearInterval(animationRef.current);
            animationRef.current = null;
          }
          setIsAnimating(false);
          return;
        }
        setCurrentImage(sequence[indexRef.current]);
        indexRef.current += 1;
      }, 75);
    }
    prevPageRef.current = currentPage;
    return () => {
      if (animationRef.current) {
        clearInterval(animationRef.current);
        animationRef.current = null;
      }
    };
  }, [currentPage]);
  return <button onClick={onClick} className="max-h-[48px] flex items-center" aria-label="Go to homepage" data-id="element-82">
      <div className="relative w-12 h-12" data-id="element-83">
        <img src={currentImage} alt="Logo icon" className="w-full h-full transition-all duration-150" style={{
        filter: currentImage === logo && currentPage === 'home' ? 'brightness(0) invert(1)' : 'none'
      }} data-id="element-84" />
      </div>
    </button>;
}